<template>
  <div class="user-message">
    <div class="user-message-container">
      <div class="user-message-content">
        <span
          v-if="showCustomData"
          class="user-message-custom-data"
        >
          <Icon
            v-if="message.customData?.icon"
            :name="message.customData?.icon"
          />
          <span
            v-if="message.customData?.text"
            class="user-message-custom-data-text"
          >
            {{ message.customData?.text }}
          </span>
        </span>
        <span>{{ message.text }}</span>
      </div>
      <div class="user-message-footer">
        <span class="message-time">{{ formattedTime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  message: { type: Object, required: true },
  isThinking: { type: Boolean, required: false }
});
const formattedTime = computed(() => {
  if (!props.message.created_at) return "";
  const date = typeof props.message.created_at === "string" ? new Date(props.message.created_at) : props.message.created_at;
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
});
const showCustomData = computed(() => {
  return props.message.customData?.text || props.message.customData?.icon;
});
</script>

<style scoped>
.user-message{align-items:flex-end;margin-left:auto;max-width:80%}.user-message,.user-message-container{display:flex;flex-direction:column;gap:8px}.user-message-container{width:100%}.user-message-content{background-color:#6366f1;border-radius:8px;border-top-right-radius:0;box-shadow:0 1px 2px 0 rgba(0,0,0,.05);color:#fff;display:flex;flex-direction:column;gap:8px;line-height:1.4;padding:12px 16px}.user-message-custom-data{align-items:center;color:#9cb4e4;display:flex;gap:8px}.user-message-custom-data-text{font-size:12px;line-height:1.33;text-transform:uppercase}.user-message-footer{display:flex;justify-content:flex-end;padding:0 4px}.message-time{color:#6b7280;font-size:12px}
</style>
